module.exports = __webpack_public_path__ + "static/media/notepad.da6768a2.png";